import { createApiMutation } from "../../generated-factory";
import { apiClientManager } from "@app/stores/api-manager";
import type { UseApplyTemplateToScheduleRequest, UseApplyTemplateToScheduleData, UseCancelActivityRequest, UseCancelActivityData, UseCancelScheduleRequest, UseCancelScheduleData, UseCompleteActivityRequest, UseCompleteActivityData, UseCompleteScheduleRequest, UseCompleteScheduleData, UseCreateActivityTypeRequest, UseCreateActivityTypeData, UseCreateGroupRequest, UseCreateGroupData, UseCreateGroupMemberPetRequest, UseCreateGroupMemberPetData, UseCreateGroupMemberUserRequest, UseCreateGroupMemberUserData, UseCreateGroupScheduleRequest, UseCreateGroupScheduleData, UseCreateRecurringPatternRequest, UseCreateRecurringPatternData, UseCreateScheduleActivityRequest, UseCreateScheduleActivityData, UseStartActivityRequest, UseStartActivityData, UseStartUsageRequest, UseStartUsageData, UseSubmitGroupMemberPetSurveyRepliesRequest, UseSubmitGroupMemberPetSurveyRepliesData, UseUploadImage1Request, UseUploadImage1Data } from "@api/@types/group";

export const useApplyTemplateToSchedule = createApiMutation<UseApplyTemplateToScheduleData, UseApplyTemplateToScheduleRequest>({
  mutationFn: (req) => apiClientManager.apis.group.applyTemplateToSchedule(req as UseApplyTemplateToScheduleRequest),
});

export const useCancelActivity = createApiMutation<UseCancelActivityData, UseCancelActivityRequest>({
  mutationFn: (req) => apiClientManager.apis.group.cancelActivity(req as UseCancelActivityRequest),
});

export const useCancelSchedule = createApiMutation<UseCancelScheduleData, UseCancelScheduleRequest>({
  mutationFn: (req) => apiClientManager.apis.group.cancelSchedule(req as UseCancelScheduleRequest),
});

export const useCompleteActivity = createApiMutation<UseCompleteActivityData, UseCompleteActivityRequest>({
  mutationFn: (req) => apiClientManager.apis.group.completeActivity(req as UseCompleteActivityRequest),
});

export const useCompleteSchedule = createApiMutation<UseCompleteScheduleData, UseCompleteScheduleRequest>({
  mutationFn: (req) => apiClientManager.apis.group.completeSchedule(req as UseCompleteScheduleRequest),
});

export const useCreateActivityType = createApiMutation<UseCreateActivityTypeData, UseCreateActivityTypeRequest>({
  mutationFn: (req) => apiClientManager.apis.group.createActivityType(req as UseCreateActivityTypeRequest),
});

export const useCreateGroup = createApiMutation<UseCreateGroupData, UseCreateGroupRequest>({
  mutationFn: (req) => apiClientManager.apis.group.createGroup(req as UseCreateGroupRequest),
});

export const useCreateGroupMemberPet = createApiMutation<UseCreateGroupMemberPetData, UseCreateGroupMemberPetRequest>({
  mutationFn: (req) => apiClientManager.apis.group.createGroupMemberPet(req as UseCreateGroupMemberPetRequest),
});

export const useCreateGroupMemberUser = createApiMutation<UseCreateGroupMemberUserData, UseCreateGroupMemberUserRequest>({
  mutationFn: (req) => apiClientManager.apis.group.createGroupMemberUser(req as UseCreateGroupMemberUserRequest),
});

export const useCreateGroupSchedule = createApiMutation<UseCreateGroupScheduleData, UseCreateGroupScheduleRequest>({
  mutationFn: (req) => apiClientManager.apis.group.createGroupSchedule(req as UseCreateGroupScheduleRequest),
});

export const useCreateRecurringPattern = createApiMutation<UseCreateRecurringPatternData, UseCreateRecurringPatternRequest>({
  mutationFn: (req) => apiClientManager.apis.group.createRecurringPattern(req as UseCreateRecurringPatternRequest),
});

export const useCreateScheduleActivity = createApiMutation<UseCreateScheduleActivityData, UseCreateScheduleActivityRequest>({
  mutationFn: (req) => apiClientManager.apis.group.createScheduleActivity(req as UseCreateScheduleActivityRequest),
});

export const useStartActivity = createApiMutation<UseStartActivityData, UseStartActivityRequest>({
  mutationFn: (req) => apiClientManager.apis.group.startActivity(req as UseStartActivityRequest),
});

export const useStartUsage = createApiMutation<UseStartUsageData, UseStartUsageRequest>({
  mutationFn: (req) => apiClientManager.apis.group.startUsage(req as UseStartUsageRequest),
});

export const useSubmitGroupMemberPetSurveyReplies = createApiMutation<UseSubmitGroupMemberPetSurveyRepliesData, UseSubmitGroupMemberPetSurveyRepliesRequest>({
  mutationFn: (req) => apiClientManager.apis.group.submitGroupMemberPetSurveyReplies(req as UseSubmitGroupMemberPetSurveyRepliesRequest),
});

export const useUploadImage1 = createApiMutation<UseUploadImage1Data, UseUploadImage1Request>({
  mutationFn: (req) => apiClientManager.apis.group.uploadImage1(req as UseUploadImage1Request),
});

export type { UseApplyTemplateToScheduleRequest, UseApplyTemplateToScheduleData, UseCancelActivityRequest, UseCancelActivityData, UseCancelScheduleRequest, UseCancelScheduleData, UseCompleteActivityRequest, UseCompleteActivityData, UseCompleteScheduleRequest, UseCompleteScheduleData, UseCreateActivityTypeRequest, UseCreateActivityTypeData, UseCreateGroupRequest, UseCreateGroupData, UseCreateGroupMemberPetRequest, UseCreateGroupMemberPetData, UseCreateGroupMemberUserRequest, UseCreateGroupMemberUserData, UseCreateGroupScheduleRequest, UseCreateGroupScheduleData, UseCreateRecurringPatternRequest, UseCreateRecurringPatternData, UseCreateScheduleActivityRequest, UseCreateScheduleActivityData, UseStartActivityRequest, UseStartActivityData, UseStartUsageRequest, UseStartUsageData, UseSubmitGroupMemberPetSurveyRepliesRequest, UseSubmitGroupMemberPetSurveyRepliesData, UseUploadImage1Request, UseUploadImage1Data } from "@api/@types/group";
